//React
import React, {FC, useState, useEffect} from 'react'

//i18n - react-intl - internationalization - locale -localization
import {useIntl} from 'react-intl'

//React-Router-Dom
import {useLocation, useNavigate} from 'react-router-dom'

//CLSX - Dynamic CSS Class Creator
import clsx from 'clsx'

//Helper
import {KTIcon} from '../../../../_metronic/helpers'

import {dateFormat} from '../../../i18n/Metronici18n'

interface ModalProps {
  modalVisible: boolean
  onCloseModal: () => void
  onContinue: (date) => void
}

const InviteModal: React.FC<ModalProps> = ({
  onCloseModal,
  onContinue,
  modalVisible = false,
}) => {
  const intl = useIntl()

  const [date, setDate] = useState(dateFormat(new Date(),'yyyy-MM-dd'))

  const [fade, setFade] = useState(false)
  useEffect(() => {
    if (modalVisible) {
      setDate(dateFormat(new Date(),'yyyy-MM-dd'))
      setTimeout(() => setFade(true), 100)
    } else {
      setFade(false)
    }
  }, [modalVisible])
  const location = useLocation()
  const modalID = `modal_${location.pathname.replace(/\//g, '_')}_warning`

  return (
    <>
      <div
        className={clsx('modal fade d-block', {show: fade})}
        id={`${modalID}`}
        role='dialog'
        tabIndex={-1}
        aria-modal={'true'}
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content bg-light-warning py-10 px-10 px-lg-20 mb-10'>
            <button
              className='position-absolute top-0 end-0 m-2 btn btn-icon btn-icon-warning'
              onClick={onCloseModal}
              style={{cursor: 'pointer'}}
            >
              <KTIcon iconName='cross' className='fs-1' />
            </button>
            {/* begin::Modal body */}
            <div className='modal-body'>
              <div className='d-flex flex-center'>
                <KTIcon iconName='information' className='fs-5tx text-warning mb-5' />
              </div>
              <div className='text-center'>
                <h1 className='fw-bold mb-5'>{intl.formatMessage({id: 'MODAL.WARNING.TITLE'})}</h1>

                <div className='separator separator-dashed border-warning opacity-25 mb-5'></div>

                <div className='mb-9 text-gray-900'>
                  <strong>{intl.formatMessage({id: 'MODAL.WARNING.INVITE_DESC'})}</strong>
                </div>
                <div className='fv-row mb-7'>
                  {/* begin::Label */}
                  <label className='required fw-bold fs-6 mb-2'>
                    {intl.formatMessage({id: 'FORM.LABEL.INVITE_DATE'})}
                  </label>
                  {/* end::Label */}

                  <input
                    type='date'
                    placeholder={''}
                    value={date}
                    className={'form-control form-control-solid  mb-3 mb-lg-0'}
                    onChange={(event) => {
                      setDate(event.target.value)
                    }}
                  />

                  {/* end::Input */}
                </div>

                <div className='d-flex flex-center flex-wrap'>
                  <button
                    className='btn btn-outline btn-outline-danger btn-active-warning m-2'
                    onClick={onCloseModal}
                  >
                    {intl.formatMessage({id: 'FORM.BUTTON.CANCEL'})}
                  </button>
                  <button
                    className='btn btn-success m-2'
                    onClick={() => {
                      onContinue(date)
                    }}
                  >
                    {intl.formatMessage({id: 'FORM.BUTTON.YES_CONTINUE'})}
                  </button>
                </div>
              </div>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className={clsx('modal-backdrop fade', {show: fade})} />

      {/* end::Modal Backdrop */}
    </>
  )
}

export default InviteModal
